import { GET_VOUCHER_WIRE_MANAGER_FAILED, GET_VOUCHER_WIRE_MANAGER_SUCCESS, LOADING_GET_VOUCHER_WIRE_MANAGER, NETWORK_ERROR_VOUCHER_WIRE_MANAGER, RESET_GET_VOUCHER_WIRE_MANAGER } from "../types"

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: '',
    networkError: '',
}

export const getVoucherWireManagerReducer = ( state = initialState, { type, payload } ) => {
    switch( type ) {
        case LOADING_GET_VOUCHER_WIRE_MANAGER: 
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: '',
                networkError: '',
            }
        case GET_VOUCHER_WIRE_MANAGER_SUCCESS: 
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: payload,
                message: '',
                networkError: '',
            }
        case GET_VOUCHER_WIRE_MANAGER_FAILED:
            return {
                ...state, 
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: payload,
                message: '',
                networkError: '',
            }
        case NETWORK_ERROR_VOUCHER_WIRE_MANAGER: {
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: "",
            }
        }
        case RESET_GET_VOUCHER_WIRE_MANAGER: {
            return ( state = initialState );
        }
        default: 
            return state;
    }
}